import * as actionTypes from '../Actions/actionTypes';

const defaultState = {
	apiFlag: true,
	Data: [],
	Data2: [],
	select: []
};

export default function setDriverReducer(state = defaultState, action = {}) {
	switch (action.type) {
		case actionTypes.SET_ALL_VEHICLE_NAME_INTO_VEHICLE_SELECT:
			return {
				...state,
				select: [...action.payload]
			};

		case actionTypes.SET_ALL_ROUTE_NAME_INTO_VEHICLE_SELECT:
			return {
				...state,
				select: [...action.payload]
			};

		case actionTypes.SET_ALL_VEHICLE_NAME_INTO_DRIVER_SELECT:
			return {
				...state,
				select: [...action.payload]
			};
		case actionTypes.GET_ALL_DRIVER:
			return { ...state, Data: [...action.payload] };
		case actionTypes.SET_LOADER_FLAG_DRIVER:
			return { ...state, apiFlag: action.payload };
		case actionTypes.DELETE_DRIVER:
			let filterCandidateReqList = state.Data.filter(
				filterOBJ => filterOBJ.id !== action.payload
			);
			return {
				...state,
				Data: filterCandidateReqList
			};
		case actionTypes.EDIT_DRIVER_RECORD:
			var adminData = [...state.Data];
			var index = adminData.findIndex(obj => obj.id === action.payload.id);
			adminData[index].driverName = action.payload.driverName;
			adminData[index].driverMobileNo = action.payload.driverMobileNo;
			adminData[index].driverIdCardNo = action.payload.driverIdCardNo;
			adminData[index].driverLicense = action.payload.driverLicense;
			adminData[index].licenseIssueDate = action.payload.licenseIssueDate;
			adminData[index].licenseExpirayDate = action.payload.licenseExpirayDate;

			return { ...state, Data: [...adminData] };
		default:
			return state;
	}
}
